__turbopack_context__.v({
  "chevronButton": "Carousel-module__G81-SG__chevronButton",
  "chevronButtons": "Carousel-module__G81-SG__chevronButtons",
  "container": "Carousel-module__G81-SG__container",
  "controlButton": "Carousel-module__G81-SG__controlButton",
  "controls": "Carousel-module__G81-SG__controls",
  "displayChevronOnHover": "Carousel-module__G81-SG__displayChevronOnHover",
  "nextButton": "Carousel-module__G81-SG__nextButton",
  "prevButton": "Carousel-module__G81-SG__prevButton",
  "root": "Carousel-module__G81-SG__root",
  "sliderRoot": "Carousel-module__G81-SG__sliderRoot",
});
